module.exports = __webpack_public_path__ + "assets/img/1_img6.c51dc787.png";